var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 60 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M57.187 10.245a7.14 7.14 0 0 0-5.02-5.051C47.743 4 29.988 4 29.988 4S12.232 4 7.807 5.194a7.14 7.14 0 0 0-5.02 5.051C1.6 14.703 1.6 24 1.6 24s0 9.297 1.187 13.755a7.13 7.13 0 0 0 5.02 5.051C12.235 44 29.986 44 29.986 44s17.755 0 22.18-1.194a7.13 7.13 0 0 0 5.02-5.051C58.374 33.3 58.374 24 58.374 24s0-9.297-1.187-13.755M24.181 32.442V15.558L39.019 24z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.6 4h56.774v40H1.6z"
  })))));
};
export default SvgYoutube;